import { render, staticRenderFns } from "./EditColumnMenu.vue?vue&type=template&id=6d995096&"
import script from "./EditColumnMenu.vue?vue&type=script&lang=js&"
export * from "./EditColumnMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditColumnMenu.vue?vue&type=style&index=0&id=6d995096&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports